import React, { useEffect, useState } from 'react';

const NotFound: React.FC = () => {
  const [glowPosition, setGlowPosition] = useState({ x: 0, y: 0 });
  const [glowPosition2, setGlowPosition2] = useState({ x: 0, y: 0 });

  // Animate glow blobs
  useEffect(() => {
    let animationId: number;
    let time = 0;

    const animate = () => {
      time += 0.02;
      setGlowPosition({
        x: Math.sin(time) * 30 + Math.sin(time * 0.5) * 20,
        y: Math.cos(time) * 10 + Math.sin(time * 0.3) * 20
      });
      setGlowPosition2({
        x: Math.sin(time * 0.7) * 20 + Math.sin(time * 0.3) * 15,
        y: Math.cos(time * 0.5) * 15 + Math.sin(time * 0.7) * 10
      });
      animationId = requestAnimationFrame(animate);
    };

    animate();
    return () => cancelAnimationFrame(animationId);
  }, []);

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-neutral-950 text-white">
      {/* Background grid */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)',
          backgroundSize: '32px 32px',
          maskImage: 'radial-gradient(ellipse at center, black, transparent 70%)'
        }}
      />

      {/* Glow blobs */}
      <div
        aria-hidden
        className="absolute -top-1/3 -left-1/4 h-[70vh] w-[70vh] rounded-full blur-3xl opacity-40 transition-transform duration-1000"
        style={{ 
          background: "conic-gradient(from 90deg at 50% 50%, #22d3ee, #a78bfa, #22d3ee)",
          transform: `translate(${glowPosition.x}px, ${glowPosition.y}px)`
        }}
      />
      <div
        aria-hidden
        className="absolute -bottom-1/3 -right-1/4 h-[60vh] w-[60vh] rounded-full blur-3xl opacity-30 transition-transform duration-1000"
        style={{ 
          background: "radial-gradient(closest-side, #fb7185, transparent)",
          transform: `translate(${glowPosition2.x}px, ${glowPosition2.y}px)`
        }}
      />

      {/* Top bar */}
      <header className="relative z-10 mx-auto flex w-full max-w-6xl items-center justify-between px-6 py-6">
        <div className="flex items-center gap-3">
          <div className="h-8 w-8 rounded-xl bg-white/10 ring-1 ring-white/15" />
          <span className="font-semibold tracking-wide text-white/90">CoreBids</span>
        </div>
        <nav className="hidden items-center gap-6 text-sm text-white/70 md:flex">
          <a href="/" className="transition hover:text-white">Home</a>
          <a href="/estimate" className="transition hover:text-white">Get Estimate</a>
          <a href="/faq" className="transition hover:text-white">FAQ</a>
        </nav>
      </header>

      {/* Main */}
      <main className="relative z-10 mx-auto flex w-full max-w-6xl flex-col items-center justify-center px-6 min-h-screen text-center">
        <h1 className="relative text-[16rem] font-extrabold leading-[0.8] tracking-tight md:text-[21rem] lg:text-[29rem] xl:text-[36rem]">
          4<span className="inline-block text-cyan-300 animate-pulse">0</span>4
        </h1>
        
        <div className="mt-8 text-center" style={{ marginTop: 'calc(2rem + 20px)' }}>
          <p className="text-[6rem] md:text-[10rem] lg:text-[12rem] font-extrabold text-white mb-4">
            Oops! page not found
          </p>
          <p style={{ fontSize: '24px', color: 'black' }}>
            The page you are looking for doesn't exist or has been moved.
          </p>
          
          {/* Back to Home Button */}
          <div className="mt-8" style={{ marginTop: 'calc(2rem + 20px)' }}>
            <a 
              href="/"
              style={{ 
                display: 'inline-flex', 
                alignItems: 'center', 
                gap: '16px', 
                padding: '12px 24px', 
                backgroundColor: '#123c3b', 
                color: '#ffffff', 
                borderRadius: '8px', 
                fontWeight: '600', 
                fontSize: '16px', 
                textDecoration: 'none',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#0d2928')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#123c3b')}
            >
              Back to Home
              <svg 
                width="30" 
                height="30" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
                style={{ transform: 'rotate(45deg)' }}
              >
                <path d="M7 17L17 7M17 7H7M17 7V17" />
              </svg>
            </a>
          </div>
        </div>
      </main>

      {/* Subtle noise texture */}
      <svg aria-hidden className="pointer-events-none absolute inset-0 opacity-20 mix-blend-soft-light" xmlns="http://www.w3.org/2000/svg">
        <filter id="n" x="0" y="0">
          <feTurbulence type="fractalNoise" baseFrequency="0.80" numOctaves="4" stitchTiles="stitch" />
          <feColorMatrix type="saturate" values="0" />
          <feComponentTransfer>
            <feFuncA type="table" tableValues="0 0 0 0 0 0.35 0" />
          </feComponentTransfer>
        </filter>
        <rect width="100%" height="100%" filter="url(#n)" />
      </svg>
    </div>
  );
};

export default NotFound; 